<section *ngIf="this.hasAccess.includes('spelleider')" class="tileGrid">
  <ng-container *ngFor="let SLAPP of SLAPPLIST">
    <a [attr.href]="SLAPP.link" target="_blank">
      <div class="border">
        <div class="flourish"></div>
        <div class="flourish"></div>
        <div class="flourish"></div>
        <div class="flourish"></div>
        <section class="linkTile">
          <figure class="icon">
            <p id="beta">{{ SLAPP.cornertag }}</p>
            <img
              src="../../assets/images/{{ SLAPP.icon }}.png"
              alt="{{ SLAPP.iconAlt }}"
            />
            <figcaption class="flourishFont">{{ SLAPP.name }}</figcaption>
          </figure>
          <aside>
            {{ SLAPP.description }}
          </aside>
        </section>
      </div>
    </a>
  </ng-container>
</section>
<hr *ngIf="this.hasAccess.includes('spelleider')" />
<main class="tileGrid">
  <ng-container *ngFor="let APP of APPLIST">
    <a [attr.href]="APP.link" target="APP.target" *ngIf="APP.showIf">
      <div class="border">
        <div class="flourish"></div>
        <div class="flourish"></div>
        <div class="flourish"></div>
        <div class="flourish"></div>
        <section class="linkTile">
          <figure class="icon">
            <p id="beta">{{ APP.cornertag }}</p>
            <img
              src="../../assets/images/{{ APP.icon }}.png"
              alt="{{ APP.iconAlt }}"
            />
            <figcaption class="flourishFont">
              <span class="appName">{{ APP.name }}</span>
            </figcaption>
          </figure>
          <aside [innerHTML]="APP.description">
            {{ APP.description }}
          </aside>
        </section>
      </div>
    </a>
  </ng-container>
</main>
